import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { Button, ButtonProps } from "../../button";
import { paginationTheme } from "../paginationTheme";

interface StyledIconButtonProps extends ButtonProps {
    themeMode: RequiredThemeKeys;
}

/**
 * TODO: Remove this component when the Button component's `small` variant is resized to 28px out of the box
 */
export const StyledIconButton = styled(Button)<StyledIconButtonProps>(
    ({ themeMode }) => `
    height: ${paginationTheme.iconButton.height(themeMode)};
    width: ${paginationTheme.iconButton.width(themeMode)};
`
);
